import { render } from "./DialogBadReception.vue?vue&type=template&id=77bc1045"
import script from "./DialogBadReception.vue?vue&type=script&lang=js"
export * from "./DialogBadReception.vue?vue&type=script&lang=js"
script.render = render

export default script